import { z } from 'zod';

export const actionSchema = z.object({
  name: z.string(),
  kwargs: z.record(z.string(), z.any()),
});

export type Action = z.infer<typeof actionSchema>;
